module.exports = __webpack_public_path__ + "static/media/bottle.1001d491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/bottle.jpg
// module id = 37
// module chunks = 0